// waist-trainer-quiz-config.js
// This file contains all customizable quiz settings

const WaistTrainerQuizConfig = {
  // Quiz Settings
  "settings": {
    "modalTitle": "FIND THE PERFECT WAIST TRAINER",
    "buttonText": "Find Perfect Size",
    "poweredByText": "Powered by PRIME AI",
    "primaryColor": "#d4a4d4",
    "secondaryColor": "#c294c2"
  },

  // Quiz Steps Configuration
  "quizSteps": [
    {
      "id": 1,
      "question": "What is your main body goal?",
      "subtitle": "Tell us what you want to achieve",
      "type": "options",
      "options": [
        { "label": "Slim waist", "value": "goal_slim_waist" },
        { "label": "Lift hips & butt", "value": "goal_bbl" },
        { "label": "Postpartum recovery", "value": "goal_postpartum" },
        { "label": "General body sculpting", "value": "goal_body_sculpt" }
      ]
    },
    {
      "id": 2,
      "question": "How much compression do you prefer?",
      "subtitle": "Choose your comfort level",
      "type": "options",
      "options": [
        { "label": "Firm compression", "value": "compression_firm", "description": "Maximum support and control" },
        { "label": "Medium compression", "value": "compression_medium", "description": "Balanced comfort and support" },
        { "label": "Light compression", "value": "compression_light", "description": "Gentle shaping and comfort" }
      ]
    },
    {
      "id": 3,
      "question": "When do you plan to use it the most?",
      "subtitle": "Select your primary use case",
      "type": "options",
      "options": [
        { "label": "Daily wear under clothes", "value": "usage_daily" },
        { "label": "Workout support", "value": "usage_workout" },
        { "label": "Postpartum recovery", "value": "usage_postpartum" },
        { "label": "Special occasions", "value": "usage_special" }
      ]
    },
    {
      "id": 4,
      "question": "What's your experience with shapewear?",
      "subtitle": "This helps us recommend the right compression level",
      "type": "options",
      "options": [
        { "label": "Beginner - New to shapewear", "value": "experience_beginner" },
        { "label": "Some experience", "value": "experience_intermediate" },
        { "label": "Very experienced", "value": "experience_experienced" }
      ]
    },
    {
      "id": 5,
      "question": "Select your body type",
      "subtitle": "Choose the shape that best describes you",
      "type": "options",
      "options": [
        { "label": "Curvy / Pear shape", "value": "body_curvy", "description": "Fuller hips and thighs" },
        { "label": "Athletic / Rectangle", "value": "body_athletic", "description": "Straight silhouette" },
        { "label": "Apple shape", "value": "body_apple", "description": "Fuller midsection" },
        { "label": "Hourglass", "value": "body_hourglass", "description": "Balanced bust and hips" },
        { "label": "Plus size", "value": "body_plus", "description": "Size 14+" }
      ]
    }
  ],

  // Product Recommendations Matrix
  "recommendations": {
    // Exact match recommendations
    "goal_slim_waist|compression_firm|usage_daily": {
      "productHandle": "firm-compression-body-sculptor",
      "title": "Firm Compression Body Sculptor",
      "description": "Perfect for daily wear to snatch your waist and smooth your curves.",
      "image": "/products/firm-body-sculptor.jpg",
      "confidence": 95
    },
    
    "goal_bbl|compression_medium|usage_daily": {
      "productHandle": "bbl-bigger-hips-shaper-1",
      "title": "BBL Bigger Hips Shaper 1.0",
      "description": "Enhance your hips and butt naturally while shaping your waist.",
      "image": "/products/bbl-hips-shaper-1.jpg",
      "confidence": 92
    },
    
    "goal_postpartum|compression_firm|usage_postpartum": {
      "productHandle": "postpartum-body-sculptor",
      "title": "Postpartum Body Sculptor",
      "description": "Designed for recovery and waist support after childbirth.",
      "image": "/products/postpartum-body-sculptor.jpg",
      "confidence": 98
    },
    
    "goal_body_sculpt|compression_medium|usage_workout": {
      "productHandle": "latex-waist-trainer",
      "title": "Latex Waist Trainer",
      "description": "Best for workouts and waist training with flexible latex compression.",
      "image": "/products/latex-waist-trainer.jpg",
      "confidence": 90
    },
    
    "goal_slim_waist|compression_medium|usage_workout": {
      "productHandle": "workout-waist-cincher",
      "title": "Workout Waist Cincher",
      "description": "Medium compression perfect for exercise and waist training.",
      "image": "/products/workout-waist-cincher.jpg",
      "confidence": 88
    },
    
    "goal_bbl|compression_firm|usage_special": {
      "productHandle": "premium-bbl-enhancer",
      "title": "Premium BBL Enhancer",
      "description": "Maximum lift and enhancement for special occasions.",
      "image": "/products/premium-bbl-enhancer.jpg",
      "confidence": 94
    },

    // Fallback recommendations based on primary goal
    "goal_slim_waist": {
      "productHandle": "classic-waist-trainer",
      "title": "Classic Waist Trainer",
      "description": "Our bestselling waist trainer for achieving that perfect hourglass shape.",
      "image": "/products/classic-waist-trainer.jpg",
      "confidence": 75
    },
    
    "goal_bbl": {
      "productHandle": "hip-enhancer-pro",
      "title": "Hip Enhancer Pro",
      "description": "Professional-grade hip and butt enhancement with waist control.",
      "image": "/products/hip-enhancer-pro.jpg",
      "confidence": 75
    },
    
    "goal_postpartum": {
      "productHandle": "recovery-support-band",
      "title": "Recovery Support Band",
      "description": "Gentle support designed specifically for postpartum recovery.",
      "image": "/products/recovery-support-band.jpg",
      "confidence": 80
    },
    
    // Default recommendation
    "default": {
      "productHandle": "versatile-body-shaper",
      "title": "Versatile Body Shaper",
      "description": "Our most popular all-purpose body shaper suitable for any goal.",
      "image": "/products/versatile-body-shaper.jpg",
      "confidence": 70
    }
  },

  // Size Calculation Rules
  "sizeRules": {
    // Base sizes by body type
    "baseSizes": {
      "body_slim": "S",
      "body_athletic": "M", 
      "body_curvy": "L",
      "body_apple": "L",
      "body_hourglass": "M",
      "body_plus": "XL"
    },
    
    // Adjustments for experience level
    "experienceAdjustments": {
      "experience_beginner": {
        "compression_firm": "+1", // Size up for beginners with firm compression
        "compression_medium": "0",
        "compression_light": "0"
      },
      "experience_intermediate": {
        "compression_firm": "0",
        "compression_medium": "0", 
        "compression_light": "-1"
      },
      "experience_experienced": {
        "compression_firm": "-1", // Size down for experienced users
        "compression_medium": "0",
        "compression_light": "-1"
      }
    },
    
    // Size progression
    "sizeOrder": ["XS", "S", "M", "L", "XL", "XXL", "3XL"]
  },

  // Alternative size suggestions
  "alternativeSizes": {
    "rules": [
      "If recommended size is S or smaller, suggest M as alternative",
      "If recommended size is L or larger, suggest M as alternative", 
      "For M, suggest both S and L as alternatives"
    ]
  },

  // Results page customization
  "resultsConfig": {
    "showConfidence": false,
    "showAlternatives": true,
    "showProductImage": true,
    "allowStartOver": true,
    "addToCartText": "ADD TO BAG",
    "alternativeText": "You may also consider:",
    "sizeText": "Your recommended size is:"
  }
};

// Advanced Quiz Logic Class with Enhanced Features
class AdvancedWaistTrainerQuiz {
  constructor(config = WaistTrainerQuizConfig) {
    this.config = config;
    this.currentStep = 1;
    this.answers = {};
    this.totalSteps = config.quizSteps.length;
    this.analytics = {
      startTime: null,
      stepTimes: {},
      completed: false
    };
  }

  // Initialize quiz
  init() {
    this.bindEvents();
    this.renderStep(1);
    this.applyCustomStyling();
  }

  // Apply custom colors from config
  applyCustomStyling() {
    const primaryColor = this.config.settings.primaryColor;
    const secondaryColor = this.config.settings.secondaryColor;
    
    const style = document.createElement('style');
    style.textContent = `
      :root {
        --quiz-primary-color: ${primaryColor};
        --quiz-secondary-color: ${secondaryColor};
      }
      .waist-trainer-quiz-button { background-color: var(--quiz-primary-color); }
      .waist-trainer-quiz-button:hover { background-color: var(--quiz-secondary-color); }
      .btn-primary { background-color: var(--quiz-primary-color); }
      .btn-primary:not(:disabled):hover { background-color: var(--quiz-secondary-color); }
      .step-number.active, .step-number.completed { background-color: var(--quiz-primary-color); }
      .step-connector.completed { background-color: var(--quiz-primary-color); }
      .waist-trainer-option input[type="radio"]:checked + label { 
        border-color: var(--quiz-primary-color); 
        background-color: var(--quiz-primary-color); 
      }
      .waist-trainer-add-to-cart { background-color: var(--quiz-primary-color); }
      .waist-trainer-add-to-cart:hover { background-color: var(--quiz-secondary-color); }
    `;
    document.head.appendChild(style);
  }

  // Enhanced step rendering with animations
  renderStep(stepNumber) {
    const step = this.config.quizSteps.find(s => s.id === stepNumber);
    if (!step) return;

    // Track analytics
    this.analytics.stepTimes[stepNumber] = Date.now();

    const content = document.getElementById('waist-trainer-quiz-content');
    
    // Add fade out animation
    content.classList.add('fade-out');
    
    setTimeout(() => {
      content.innerHTML = this.generateStepHTML(step);
      content.classList.remove('fade-out');
      content.classList.add('fade-in');
      
      // Bind events for new step
      this.bindStepEvents(step);
      this.updateNavigationButtons();
      this.updateStepIndicators();
      
      // Remove animation class
      setTimeout(() => {
        content.classList.remove('fade-in');
      }, 300);
    }, 150);
  }

  // Generate HTML for different step types
  generateStepHTML(step) {
    let html = `<div class="waist-trainer-quiz-step active">`;
    html += `<h3 class="waist-trainer-step-question">${step.question}</h3>`;
    
    if (step.subtitle) {
      html += `<p class="waist-trainer-step-subtitle">${step.subtitle}</p>`;
    }

    switch (step.type) {
      case 'options':
        html += this.generateOptionsHTML(step);
        break;
      case 'dropdown':
        html += this.generateDropdownHTML(step);
        break;
      case 'input':
        html += this.generateInputHTML(step);
        break;
      case 'size_grid':
        html += this.generateSizeGridHTML(step);
        break;
    }

    html += `</div>`;
    return html;
  }

  generateOptionsHTML(step) {
    let html = `<div class="waist-trainer-options">`;
    step.options.forEach((option, index) => {
      const isChecked = this.answers[step.id] === option.value ? 'checked' : '';
      html += `
        <div class="waist-trainer-option">
          <input type="radio" id="option-${step.id}-${index}" name="step-${step.id}" value="${option.value}" ${isChecked}>
          <label for="option-${step.id}-${index}">
            ${option.label}
            ${option.description ? `<span class="option-description">${option.description}</span>` : ''}
          </label>
        </div>
      `;
    });
    html += `</div>`;
    return html;
  }

  generateSizeGridHTML(step) {
    let html = `<div class="waist-trainer-size-selection">`;
    
    if (step.categories) {
      step.categories.forEach(category => {
        html += `<div class="size-category">`;
        html += `<h4>${category.name}</h4>`;
        html += `<div class="waist-trainer-size-grid">`;
        
        category.options.forEach((option, index) => {
          const isChecked = this.answers[step.id] === option.value ? 'checked' : '';
          html += `
            <div class="waist-trainer-size-option">
              <input type="radio" id="size-${step.id}-${index}" name="step-${step.id}" value="${option.value}" ${isChecked}>
              <label for="size-${step.id}-${index}">${option.label}</label>
            </div>
          `;
        });
        
        html += `</div></div>`;
      });
    }
    
    html += `</div>`;
    return html;
  }

  generateInputHTML(step) {
    let html = `<div class="waist-trainer-inputs">`;
    
    step.fields.forEach((field, index) => {
      const value = this.answers[`${step.id}_${field.name}`] || '';
      html += `
        <div class="waist-trainer-input-group">
          <label>${field.label}</label>
          <input type="${field.type}" 
                 id="input-${step.id}-${index}" 
                 name="${step.id}_${field.name}" 
                 value="${value}"
                 placeholder="${field.placeholder || ''}"
                 ${field.required ? 'required' : ''}>
          ${field.units ? this.generateUnitsSelector(field.units, step.id, field.name) : ''}
        </div>
      `;
    });
    
    html += `</div>`;
    return html;
  }

  generateUnitsSelector(units, stepId, fieldName) {
    let html = `<div class="unit-selector">`;
    units.forEach((unit, index) => {
      const activeClass = index === 0 ? 'active' : '';
      html += `<div class="unit-option ${activeClass}" data-unit="${unit}" data-step="${stepId}" data-field="${fieldName}">${unit}</div>`;
    });
    html += `</div>`;
    return html;
  }

  // Enhanced recommendation algorithm
  getRecommendation() {
    const answers = this.answers;
    
    // Try exact match first
    const exactKey = this.buildRecommendationKey(answers);
    let recommendation = this.config.recommendations[exactKey];
    
    if (recommendation) {
      recommendation.matchType = 'exact';
      recommendation.size = this.calculateOptimalSize(answers);
      return recommendation;
    }
    
    // Try partial matches
    const partialMatches = this.findPartialMatches(answers);
    if (partialMatches.length > 0) {
      recommendation = partialMatches[0];
      recommendation.matchType = 'partial';
      recommendation.size = this.calculateOptimalSize(answers);
      return recommendation;
    }
    
    // Fallback to goal-based recommendation
    const goalKey = answers[1]; // First question is usually the goal
    recommendation = this.config.recommendations[goalKey] || this.config.recommendations.default;
    recommendation.matchType = 'fallback';
    recommendation.size = this.calculateOptimalSize(answers);
    
    return recommendation;
  }

  buildRecommendationKey(answers) {
    // Build key from first 3 answers (goal, compression, usage)
    return `${answers[1]}|${answers[2]}|${answers[3]}`;
  }

  findPartialMatches(answers) {
    const matches = [];
    
    // Search for recommendations that match 2 out of 3 key criteria
    Object.keys(this.config.recommendations).forEach(key => {
      if (key.includes('|')) {
        const keyParts = key.split('|');
        const matchCount = keyParts.filter(part => 
          Object.values(answers).includes(part)
        ).length;
        
        if (matchCount >= 2) {
          const rec = { ...this.config.recommendations[key] };
          rec.confidence = (matchCount / keyParts.length) * 100;
          matches.push(rec);
        }
      }
    });
    
    // Sort by confidence
    return matches.sort((a, b) => b.confidence - a.confidence);
  }

  calculateOptimalSize(answers) {
    const bodyType = answers[5];
    const experience = answers[4];
    const compression = answers[2];
    
    // Get base size from body type
    let baseSize = this.config.sizeRules.baseSizes[bodyType] || 'M';
    
    // Apply experience adjustments
    const experienceRule = this.config.sizeRules.experienceAdjustments[experience];
    if (experienceRule && experienceRule[compression]) {
      const adjustment = experienceRule[compression];
      baseSize = this.adjustSize(baseSize, adjustment);
    }
    
    return baseSize;
  }

  adjustSize(currentSize, adjustment) {
    const sizes = this.config.sizeRules.sizeOrder;
    const currentIndex = sizes.indexOf(currentSize);
    
    if (adjustment === '+1' && currentIndex < sizes.length - 1) {
      return sizes[currentIndex + 1];
    } else if (adjustment === '-1' && currentIndex > 0) {
      return sizes[currentIndex - 1];
    }
    
    return currentSize;
  }

  getAlternativeSize(currentSize) {
    const sizes = this.config.sizeRules.sizeOrder;
    const currentIndex = sizes.indexOf(currentSize);
    
    // Suggest neighboring sizes
    const alternatives = [];
    if (currentIndex > 0) alternatives.push(sizes[currentIndex - 1]);
    if (currentIndex < sizes.length - 1) alternatives.push(sizes[currentIndex + 1]);
    
    return alternatives[0] || currentSize;
  }

  // Analytics and tracking
  trackEvent(eventName, data = {}) {
    console.log('Quiz Analytics:', {
      event: eventName,
      step: this.currentStep,
      answers: this.answers,
      timestamp: Date.now(),
      ...data
    });
    
    // Send to analytics service (customize as needed)
    if (typeof gtag !== 'undefined') {
      gtag('event', eventName, {
        event_category: 'Waist Trainer Quiz',
        event_label: `Step ${this.currentStep}`,
        custom_map: data
      });
    }
  }

  // Enhanced results display
  showResults() {
    this.analytics.completed = true;
    this.trackEvent('quiz_completed', {
      completion_time: Date.now() - this.analytics.startTime,
      total_steps: this.totalSteps
    });

    const recommendation = this.getRecommendation();
    const resultsContainer = document.getElementById('waist-trainer-quiz-results');
    const contentContainer = document.getElementById('waist-trainer-quiz-content');
    
    contentContainer.style.display = 'none';
    resultsContainer.style.display = 'block';
    
    const alternativeSize = this.getAlternativeSize(recommendation.size);
    const confidence = recommendation.confidence || 85;
    
    resultsContainer.innerHTML = `
      <div class="waist-trainer-results-content fade-in">
        <div class="waist-trainer-result-product">
          <h3>${this.config.resultsConfig.sizeText}</h3>
          <div class="waist-trainer-result-size">${recommendation.size}</div>
          <h4 class="waist-trainer-result-title">${recommendation.title}</h4>
          <p class="waist-trainer-result-description">${recommendation.description}</p>
          
          ${this.config.resultsConfig.showConfidence ? 
            `<div class="confidence-score">Match confidence: ${Math.round(confidence)}%</div>` : ''}
          
          <button class="waist-trainer-add-to-cart" onclick="AdvancedWaistTrainerQuiz.addToCart('${recommendation.productHandle}', '${recommendation.size}')">
            ${this.config.resultsConfig.addToCartText}
          </button>
        </div>
        
        ${this.config.resultsConfig.showAlternatives ? `
        <div class="waist-trainer-result-alternative">
          <h4>${this.config.resultsConfig.alternativeText}</h4>
          <div class="waist-trainer-alternative-size">${alternativeSize}</div>
          <button class="waist-trainer-add-to-cart" onclick="AdvancedWaistTrainerQuiz.addToCart('${recommendation.productHandle}', '${alternativeSize}')">
            ${this.config.resultsConfig.addToCartText}
          </button>
        </div>` : ''}
        
        <div style="margin-top: 25px;">
          ${this.config.resultsConfig.allowStartOver ? 
            `<button class="btn-secondary" onclick="waistTrainerQuiz.startOver()" style="margin-right: 10px;">START OVER</button>` : ''}
          <button class="btn-secondary" onclick="waistTrainerQuiz.closeModal()">CLOSE</button>
        </div>
      </div>
    `;
    
    // Hide navigation
    document.querySelector('.waist-trainer-nav-buttons').style.display = 'none';
    this.updateStepIndicators();
  }

  // Enhanced add to cart with size selection
  static addToCart(productHandle, size = null) {
    console.log('Adding to cart:', { productHandle, size });
    
    // Track the add to cart event
    if (window.waistTrainerQuiz) {
      window.waistTrainerQuiz.trackEvent('add_to_cart', { 
        product: productHandle, 
        recommended_size: size 
      });
    }
    
    // Method 1: Redirect to product page with size parameter
    let url = `/products/${productHandle}`;
    if (size) {
      url += `?variant=${size}`;
    }
    window.location.href = url;
    
    // Method 2: Use Shopify Ajax Cart (uncomment and customize)
    /*
    // First, fetch product data to get variant ID by size
    fetch(`/products/${productHandle}.js`)
      .then(response => response.json())
      .then(product => {
        // Find variant by size (customize this logic based on your variant structure)
        const variant = product.variants.find(v => 
          v.title.includes(size) || v.option1 === size || v.option2 === size
        ) || product.variants[0];
        
        // Add to cart
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variant.id, quantity: 1 }]
          })
        });
      })
      .then(response => response.json())
      .then(data => {
        // Success - close modal and show cart notification
        if (window.waistTrainerQuiz) {
          window.waistTrainerQuiz.closeModal();
        }
        
        // Trigger cart drawer or notification
        document.dispatchEvent(new CustomEvent('cart:updated'));
        
        // Show success message
        alert(`Added ${product.title} (Size ${size}) to your cart!`);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        alert('Sorry, there was an error adding the item to your cart.');
      });
    */
  }

  // Start over functionality
  startOver() {
    this.currentStep = 1;
    this.answers = {};
    this.analytics = {
      startTime: Date.now(),
      stepTimes: {},
      completed: false
    };
    
    document.getElementById('waist-trainer-quiz-results').style.display = 'none';
    document.getElementById('waist-trainer-quiz-content').style.display = 'block';
    document.querySelector('.waist-trainer-nav-buttons').style.display = 'flex';
    
    this.renderStep(1);
    this.trackEvent('quiz_restarted');
  }

  // Enhanced event binding
  bindStepEvents(step) {
    // Radio button events
    const inputs = document.querySelectorAll(`input[name="step-${step.id}"], input[name^="${step.id}_"]`);
    inputs.forEach(input => {
      input.addEventListener('change', (e) => {
        if (e.target.type === 'radio') {
          this.answers[step.id] = e.target.value;
        } else {
          // Handle other input types
          this.answers[e.target.name] = e.target.value;
        }
        this.updateNavigationButtons();
        this.trackEvent('answer_selected', { 
          step: step.id, 
          answer: e.target.value 
        });
      });
    });

    // Unit selector events
    const unitOptions = document.querySelectorAll('.unit-option');
    unitOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        // Remove active from siblings
        e.target.parentNode.querySelectorAll('.unit-option').forEach(sibling => {
          sibling.classList.remove('active');
        });
        // Add active to clicked
        e.target.classList.add('active');
        
        // Update related input if exists
        const stepId = e.target.dataset.step;
        const fieldName = e.target.dataset.field;
        this.answers[`${stepId}_${fieldName}_unit`] = e.target.dataset.unit;
      });
    });
  }

  // Enhanced navigation
  nextStep() {
    if (this.currentStep < this.totalSteps) {
      this.trackEvent('step_completed', { from_step: this.currentStep });
      this.currentStep++;
      this.renderStep(this.currentStep);
    } else {
      this.showResults();
    }
  }

  prevStep() {
    if (this.currentStep > 1) {
      this.trackEvent('step_back', { from_step: this.currentStep });
      this.currentStep--;
      this.renderStep(this.currentStep);
    }
  }

  updateNavigationButtons() {
    const continueBtn = document.getElementById('waist-trainer-continue-btn');
    const backBtn = document.getElementById('waist-trainer-back-btn');
    
    // Check if current step has required answer
    const hasAnswer = this.hasValidAnswer();
    continueBtn.disabled = !hasAnswer;
    
    // Update button text
    if (this.currentStep === this.totalSteps) {
      continueBtn.textContent = 'GET RECOMMENDATION';
    } else {
      continueBtn.textContent = 'CONTINUE >';
    }
    
    // Show/hide back button
    backBtn.style.display = this.currentStep > 1 ? 'block' : 'none';
  }

  hasValidAnswer() {
    const currentStepConfig = this.config.quizSteps.find(s => s.id === this.currentStep);
    
    if (currentStepConfig.type === 'options' || currentStepConfig.type === 'size_grid') {
      return this.answers[this.currentStep] !== undefined;
    } else if (currentStepConfig.type === 'input') {
      // Check if all required fields are filled
      return currentStepConfig.fields.every(field => {
        if (field.required) {
          const value = this.answers[`${this.currentStep}_${field.name}`];
          return value && value.trim() !== '';
        }
        return true;
      });
    }
    
    return false;
  }

  updateStepIndicators() {
    const indicators = document.querySelectorAll('.step-number');
    const connectors = document.querySelectorAll('.step-connector');
    
    indicators.forEach((indicator, index) => {
      const stepNum = index + 1;
      indicator.classList.remove('active', 'completed');
      
      if (stepNum < this.currentStep) {
        indicator.classList.add('completed');
      } else if (stepNum === this.currentStep) {
        indicator.classList.add('active');
      }
    });
    
    connectors.forEach((connector, index) => {
      connector.classList.remove('completed');
      if (index + 1 < this.currentStep) {
        connector.classList.add('completed');
      }
    });
  }

  openModal() {
    document.getElementById('waist-trainer-quiz-modal').classList.add('active');
    document.body.style.overflow = 'hidden';
    this.analytics.startTime = Date.now();
    this.trackEvent('quiz_started');
  }

  closeModal() {
    document.getElementById('waist-trainer-quiz-modal').classList.remove('active');
    document.body.style.overflow = '';
    
    if (!this.analytics.completed) {
      this.trackEvent('quiz_abandoned', {
        step_reached: this.currentStep,
        time_spent: Date.now() - this.analytics.startTime
      });
    }
  }

  // Bind all events
  bindEvents() {
    document.getElementById('waist-trainer-quiz-btn').addEventListener('click', () => {
      this.openModal();
    });

    document.getElementById('waist-trainer-close').addEventListener('click', () => {
      this.closeModal();
    });

    document.querySelector('.waist-trainer-modal-overlay').addEventListener('click', () => {
      this.closeModal();
    });

    document.getElementById('waist-trainer-continue-btn').addEventListener('click', () => {
      this.nextStep();
    });

    document.getElementById('waist-trainer-back-btn').addEventListener('click', () => {
      this.prevStep();
    });

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (document.getElementById('waist-trainer-quiz-modal').classList.contains('active')) {
        switch(e.key) {
          case 'Escape':
            this.closeModal();
            break;
          case 'Enter':
            if (!document.getElementById('waist-trainer-continue-btn').disabled) {
              this.nextStep();
            }
            break;
          case 'ArrowLeft':
            if (this.currentStep > 1) {
              this.prevStep();
            }
            break;
        }
      }
    });
  }
}

// Initialize quiz when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  window.waistTrainerQuiz = new AdvancedWaistTrainerQuiz();
  window.waistTrainerQuiz.init();
});

// Export for global access
window.AdvancedWaistTrainerQuiz = AdvancedWaistTrainerQuiz;